import React from "react";
import { useMsal } from "@azure/msal-react";
import Button from "@mui/material/Button";
import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTenant } from "../../contexts/tenant-context";
import { clearSessionCache } from "../../services/userService";

type LoginLogoutButtonProps = {
  showBugReport?: boolean;
};

const LoginLogoutButton: React.FC<LoginLogoutButtonProps> = ({ showBugReport = true }) => {
  const { instance, accounts } = useMsal();
  const navigate = useNavigate();
  const { hasMultipleTenants, setSelectedTenantId, setUserSession } = useTenant();

  const handleLogout = () => {
    // Ensure next login lands on dashboard instead of previous link.
    sessionStorage.setItem('pontis_intentional_logout', 'true');
    
    // Clear cached tenant data and session cache before logout
    localStorage.removeItem('pontis_active_account_home_id');
    localStorage.removeItem('pontis_selected_tenant_id');
    localStorage.removeItem('pontis_selected_tenant_role');
    clearSessionCache();
    setSelectedTenantId(null);
    instance.logoutPopup();
  };

  const handleSwitchTenant = () => {
    // Clear selected tenant, session, and cache for a completely fresh tenant selection
    clearSessionCache();
    setSelectedTenantId(null);
    setUserSession(null);
    navigate("/auth-loading");
  };

  const handleOpenBugReport = () => {
    navigate("/app-management/bug-reports");
  };

  // Only show Switch Tenant if user has multiple options to choose from
  const showSwitchTenant = hasMultipleTenants;

  if (accounts && accounts.length > 0) {
    // User is logged in
    return (
      <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
        {showSwitchTenant && (
          <Button
            onClick={handleSwitchTenant}
            sx={{
              color: "hsl(19 101% 51% / 1)",
              fontWeight: 600,
            }}
          >
            Switch Tenant
          </Button>
        )}
        {showBugReport && (
          <Button
            onClick={handleOpenBugReport}
            sx={{
              color: "hsl(19 101% 51% / 1)",
              fontWeight: 600,
            }}
          >
            Open Bug Report
          </Button>
        )}
        <Button
          onClick={handleLogout}
          sx={{
            color: "hsl(19 101% 51% / 1)",
            fontWeight: 600,
          }}
        >
          Logout
        </Button>
      </Box>
    );
  }
  // If not logged in, render nothing (login button is on login page)
  return null;
};

export default LoginLogoutButton;
